"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryBillingAutomationWeb = void 0;
const SvcBillingAutomationWebClient_1 = require("../Client/SvcBillingAutomationWebClient");
const ChargebeeRepository_1 = require("../Repository/ChargebeeRepository");
const CheckoutRepository_1 = require("../Repository/CheckoutRepository");
const CompanyRegistrationRepository_1 = require("../Repository/CompanyRegistrationRepository");
const OrganisationRepository_1 = require("../Repository/OrganisationRepository");
const PortalSessionRepository_1 = require("../Repository/PortalSessionRepository");
const QuoteRepository_1 = require("../Repository/QuoteRepository");
const SelfServeRepository_1 = require("../Repository/SelfServeRepository");
const ShopRepository_1 = require("../Repository/ShopRepository");
class FactoryBillingAutomationWeb {
    static create(url, configClient) {
        FactoryBillingAutomationWeb.client || (FactoryBillingAutomationWeb.client = new SvcBillingAutomationWebClient_1.SvcBillingAutomationWebClient(url, configClient));
        return {
            chargebee: new ChargebeeRepository_1.ChargebeeRepository(FactoryBillingAutomationWeb.client),
            checkout: new CheckoutRepository_1.CheckoutRepository(FactoryBillingAutomationWeb.client),
            companyRegistration: new CompanyRegistrationRepository_1.CompanyRegistrationRepository(FactoryBillingAutomationWeb.client),
            organisation: new OrganisationRepository_1.OrganisationRepository(FactoryBillingAutomationWeb.client),
            portalSession: new PortalSessionRepository_1.PortalSessionRepository(FactoryBillingAutomationWeb.client),
            quote: new QuoteRepository_1.QuoteRepository(FactoryBillingAutomationWeb.client),
            selfServe: new SelfServeRepository_1.SelfServeRepository(FactoryBillingAutomationWeb.client),
            shop: new ShopRepository_1.ShopRepository(FactoryBillingAutomationWeb.client),
        };
    }
}
exports.FactoryBillingAutomationWeb = FactoryBillingAutomationWeb;
//# sourceMappingURL=FactoryBillingAutomationWeb.js.map